import { gql } from '@apollo/client';

export * from './escrowInvitation.query.generated';

export const ESCROW_INVITATION = gql`
  query escrowInvitation($id: ID!) {
    escrowInvitation(escrowInvitationId: $id) {
      id
      status
      appName
      companyName
      partyType
      policy {
        accept
        reject
        update
      }
      escrow {
        id
        productType
        beneficiary {
          id
          companyName
          companyWebsite
        }
        depositor {
          id
          companyName
          companyWebsite
        }
      }
    }
  }
`;
